import Grid2 from '@mui/material/Grid2';
import { Container } from '@mui/material';
import { useRef } from 'react';
import type { RecentFilesCardRef } from './components/cards/RecentFilesCard';
import type { WeeklyTransactionsStatusCardRef } from './components/cards/WeeklyTransactionsStatusCard';
import type { RecentEligibilityUpdatesCardRef } from './components/cards/RecentEligibilityUpdatesCard';
import PendingTransactionsCard from './components/cards/PendingTransactionsCard';
// import RecentFilesCard from './components/cards/RecentFilesCard';
import WeeklyTransactionsStatusCard from './components/cards/WeeklyTransactionsStatusCard';
import RecentEligibilityUpdatesCard from './components/cards/RecentEligibilityUpdatesCard';

const Dashboard = () => {
  const recentFilesCardRef = useRef<RecentFilesCardRef>(null);
  const weeklyTransactionsCardRef = useRef<WeeklyTransactionsStatusCardRef>(null);
  const recentEligibilityUpdatesCardRef = useRef<RecentEligibilityUpdatesCardRef>(null);

  const handleProcessSuccess = () => {
    recentFilesCardRef.current?.fetchData();
    weeklyTransactionsCardRef.current?.fetchData();
    recentEligibilityUpdatesCardRef.current?.fetchData();
  };

  const handleProcessError = () => {
    recentFilesCardRef.current?.fetchData();
    weeklyTransactionsCardRef.current?.fetchData();
    recentEligibilityUpdatesCardRef.current?.fetchData();
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Grid2 container spacing={3}>
        {/* Left Column - Status Cards */}
        <Grid2 size={{ xs: 12, md: 4 }}>
          <PendingTransactionsCard 
            onProcessSuccess={handleProcessSuccess}
            onProcessError={handleProcessError}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <RecentEligibilityUpdatesCard ref={recentEligibilityUpdatesCardRef} />
          
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <WeeklyTransactionsStatusCard ref={weeklyTransactionsCardRef} />
        </Grid2>
        
        {/* Second Row */}
        <Grid2 size={{ xs: 12, md: 4 }}>
          {/*<RecentFilesCard ref={recentFilesCardRef} />*/}
        </Grid2>
        
        {/* Right Column - File Upload Zone */}
        <Grid2 size={{ xs: 12, md: 8 }}>
          {/*<FileUploadZone />*/}
        </Grid2>
      </Grid2>
    </Container>
  );
};

export default Dashboard;
